import ChannelPageSelector from './index'

const ChannelPageSelectorField = (props) => {
  const { field, ...restProps } = props
  // const { touched, errors } = form

  return (
    <ChannelPageSelector
      {...restProps}
      onFacebookPageSelect={(pageId) => {
        field.onChange(field.name)(pageId)
      }}
      selectedFacebookPageId={field.value}
    />
  )
}

export default ChannelPageSelectorField
